import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/home/solution/en_home_goldcircle.png'
import _imports_1 from '../../../public/img/home/case/15-en_more.png'


const _withScopeId = n => (_pushScopeId("data-v-a669b0cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"home-title\" data-v-a669b0cc><div class=\"title\" style=\"display:flex;align-items:center;color:#000;margin:7px 0;\" data-v-a669b0cc><img src=\"" + _imports_0 + "\" alt=\"\" data-v-a669b0cc><div style=\"display:flex;flex-direction:column;\" data-v-a669b0cc><p style=\"color:#000;font-size:20px;margin-left:-15px;margin-top:10px;letter-spacing:2px;\" data-v-a669b0cc>PRESS RELEASES</p><p class=\"desc\" style=\"color:#AAABAC;font-size:15px;display:flex;align-items:center;margin:5px auto;font-weight:200;\" data-v-a669b0cc>MORE <img src=\"" + _imports_1 + "\" style=\"margin-left:10px;cursor:pointer;\" alt=\"\" data-v-a669b0cc></p></div></div></div>", 1)
const _hoisted_2 = { class: "press-content" }
const _hoisted_3 = ["item"]
const _hoisted_4 = { style: {"display":"flex","justify-content":"space-between","align-items":"baseline"} }
const _hoisted_5 = { style: {"color":"#000","font-size":"0.8rem","max-width":"70%","line-height":"1.7"} }
const _hoisted_6 = { style: {"color":"rgba(0, 0, 0,0.5)"} }

import { ref, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Press',
  setup(__props) {

const datas = reactive([
  {
    name: "FENDAN TECHNOLOGY CLOSES SERIES B STRATEGIC FINANCING TO FURTHER ITS GROWTH IN MARRIAGE AND CHILDBEARING SECTORS",
    date: "2019-08-13",
  },
  {
    name: "FENDAN TECHNOLOGY AWARDED THE “GOLDEN ROSE” MOST POTENTIAL ENTERPRISE OF WEDDING INDUSTRY",
    date: "2018-12-09",
  },
  {
    name: "FENDAN TECHNOLOGY CLOSES SERIES A FINANCING",
    date: "2017-08-07",
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          item: item
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.date), 1)
          ]),
          _createElementVNode("hr", {
            style: _normalizeStyle([{"margin":"1.5rem 0","border-top":"1px solid #ccc"}, {display: index === datas.length - 1 ? 'none' : ''}])
          }, null, 4)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ], 64))
}
}

})